import CampusesWeights from './CampusesWeights.component';

export default CampusesWeights;
